exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".containerTitle{\n  font-size:60px;\n  font-weight: 900;\n  color: white;\n}\n.aboutContainer{\n  padding: 15rem 20px;\n  margin: 5rem 0;\n}\n.aboutContainer p{\n    font-size: 20px;\n    color: white;\n    font-weight: 200;\n    text-align: left;\n}\nimg{\n  max-width: 100%;\n  border-radius: 8px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/app/about/about.component.css
// module id = ../../../../../src/app/about/about.component.css
// module chunks = main